import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'tools-inline-refresh',
  templateUrl: './inline-refresh.component.html',
  styleUrls: ['./inline-refresh.component.scss']
})
export class InlineRefreshComponent implements OnInit {

    @Output() refresh: EventEmitter<number> = new EventEmitter<number>();
    @Input() autoRefreshInterval: number = 5 * 60; // Seconds

    autoRefresh: boolean = false;

    constructor() { }

    ngOnInit(): void {
    }

    toggleAutoRefresh() {
    this.autoRefresh = !this.autoRefresh;
    if (this.autoRefresh === true) { // Auto refresh changed from Off to On.
      this.refresh.emit(this.autoRefreshInterval);
    } else { // Auto refresh changed from On to Off.
      this.refresh.emit(0);
    }
  }

  autoRefreshIntervalChanged(selected) {
    this.refresh.emit(0);
    this.autoRefreshInterval = selected.value;
    if (this.autoRefresh === true) {
      this.refresh.emit(this.autoRefreshInterval);
    }
  }

}
